import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ErpDate, ErpDateClassType } from '../../../../@models/erp/compilation';
import { uuid } from '../../../../@core/common/global';

@Component({
  selector: 'ngx-doc-form-date',
  templateUrl: './doc-form-date.component.html',
  styleUrls: ['./doc-form-date.component.scss'],
})
export class DocFormDateComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() value: string | Date;
  @Input() text: string;
  @Input() textToggle: boolean;
  @Input() disabled: boolean = false;
  @Input() styles: any;
  @Input() erpDate: ErpDateClassType;
  @Output() valueChange: EventEmitter<string | Date> = new EventEmitter<string | Date>();
  @Output() textChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('dp') datepickerRef;

  dateModel: NgbDateStruct;

  dateValue: Date = null;
  textValue: string;
  isDate: boolean = true;

  showRemark = true;

  uid = '';

  constructor() {
    this.dateValue = null;
    this.textValue = '';
  }

  ngOnInit() {
    if (this.value != null && this.value !== '' && this.value !== undefined) {
      this.dateValue = new Date(this.value);
    }
    // console.log('value ', this.value, this.dateValue)
    this.uid = `date-${uuid().slice(0, 8)}`;

    this.setModel(this.dateValue);
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.value && changes.value.currentValue) {
  //     this.dateValue = new Date(changes.value.currentValue);
  //     this.isDate = true;
  //     this.setModel(this.dateValue);
  //   } else if (changes.value && changes.value.currentValue == null) {
  //     this.dateValue = null;
  //     this.setModel(this.dateValue);
  //   }
  //   if (changes.text && changes.text.currentValue && changes.text.currentValue !== '') {
  //     this.textValue = changes.text.currentValue;
  //     this.isDate = false;
  //   } else if (changes.text) {
  //     this.textValue = '';
  //   }
  // }
  ngOnChanges(changes: SimpleChanges) {
  if (changes.value) {
    if (changes.value.currentValue) {
      this.dateValue = new Date(changes.value.currentValue);
      this.setModel(this.dateValue);
    } else {
      this.dateValue = null;
      this.dateModel = null;
    }
  }
}

  setModel(date: Date = new Date()) {
    this.dateModel = date ? { day: date.getUTCDate(), month: date.getUTCMonth()+1, year: date.getUTCFullYear() } : null;
  }

  emitDate(date: Date = new Date()) {
    this.value = date;
    this.valueChange.emit(date);
    this.close();
  }

  close() {
    this.datepickerRef.close();
  }

  // update(date: Date) {
  //   this.value = date.toISOString();
  //   this.valueChange.emit(moment(date).subtract('m', date.getTimezoneOffset()).toISOString());
  // }

  updateText(text: string) {
    this.text = text;
    this.textChange.emit(text);
  }

  updateDate(ngbDate: NgbDateStruct) {
    const jsDate = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    this.value = jsDate.toISOString();
    this.valueChange.emit(moment(jsDate).subtract('m', jsDate.getTimezoneOffset()).toISOString());
  }

  onDateModelChange(model: NgbDateStruct | null) {
    if (!model) {
      this.value = null;
      this.valueChange.emit(null);
      return;
    }

    const { year, month, day } = model;

    // guard against partial / invalid input
    if (!year || !month || !day) {
      return;
    }

    const jsDate = new Date(year, month - 1, day);

    // final safety check
    if (isNaN(jsDate.getTime())) {
      return;
    }

    this.value = jsDate.toISOString();
    this.valueChange.emit(
      moment(jsDate).subtract('m', jsDate.getTimezoneOffset()).toISOString()
    );
  }

  toggle() {
    this.isDate = !this.isDate;
    if (this.isDate && (!(this.dateValue instanceof Date) || isNaN(this.dateValue.getTime()))) {
      this.dateValue = null;
    }
  }

  clear() {
    this.value = null;
    this.dateValue = null;
    this.valueChange.emit(null);
  }
}
